import React from 'react'

import TextButton from 'components/Luxkit/Button/TextButton'
import useBedbankSelectDates from 'hooks/OfferPage/useBedbankSelectDates'

function BedbankSelectDates() {
  const onCalendarOpenSelectDates = useBedbankSelectDates()

  return (<TextButton
    kind="primary"
    onClick={onCalendarOpenSelectDates}
    data-testid="select-your-dates-button"
  >
    Check availability
  </TextButton>)
}

export default BedbankSelectDates
